module.exports = __webpack_public_path__ + "img/2.a84c8bda.jpg";